import React from "react";
import invariant from "fbjs/lib/invariant";
import classNames from "classnames";
import PropTypes from "prop-types";
import { keyToComponent } from "./iconList";

export const whitelist = Object.keys(keyToComponent).sort();

const WrapperDefault = ({ children }) => {
  return <>{children}</>;
};

WrapperDefault.propTypes = {
  children: PropTypes.node.isRequired,
};

const WrapperWithAppearance = ({ children, appearance, size }) => {
  const className = classNames("icon-wrapper", {
    [`icon-wrapper--${appearance}`]: appearance,
    [`icon-wrapper--${size}`]: size,
  });
  return <span className={className}>{children}</span>;
};

WrapperWithAppearance.propTypes = {
  children: PropTypes.node.isRequired,
  appearance: PropTypes.oneOf([
    "default",
    "default-block",
    "block",
    "round",
    "round-border",
  ]),
  size: PropTypes.oneOf(["default", "small", "mini", "medium", "big"]),
};

const wrapperComponents = {
  default: WrapperDefault,
  withAppearance: WrapperWithAppearance,
};

const Svg = ({
  type,
  className = "",
  appearance = null,
  size = null,
  ...props
}) => {
  invariant(whitelist.indexOf(type) > -1, `"${type}" is not a whitelisted svg`);
  if (
    process.env.NODE_ENV === "development" &&
    (type === undefined || type === "")
  ) {
    console.warn("You must set a type.");
  }

  const svgElement = keyToComponent[type];
  const mergedClassName = classNames(
    svgElement.props.className || "",
    className,
    {
      [`icon--${size}`]: size,
      [`icon--${appearance}`]: appearance,
      [`icon--${type}`]: type,
    }
  );

  const Wrapper = appearance
    ? wrapperComponents.withAppearance
    : wrapperComponents.default;

  const svgWithProps = React.cloneElement(svgElement, {
    ...svgElement.props,
    ...props,
    className: mergedClassName,
  });

  return (
    <Wrapper appearance={appearance} size={size}>
      {svgWithProps}
    </Wrapper>
  );
};

Svg.defaultProps = {
  size: "default",
  appearance: "default",
};

Svg.propTypes = {
  type: PropTypes.string.isRequired,
  appearance: PropTypes.oneOf([
    "default",
    "default-block",
    "block",
    "round",
    "round-border",
  ]),
  size: PropTypes.oneOf(["default", "small", "mini", "medium", "big"]),
  className: PropTypes.string,
};

export default Svg;
